import React from 'react';
import { AlertTriangle, AlertCircle, Clock } from 'lucide-react';

/**
 * Componente de alerta de vencimiento
 * Muestra diferentes alertas según los días restantes
 */
export default function ExpirationAlert({ fechaVencimiento, diasRestantes }) {
  if (!fechaVencimiento) return null;

  // Documento vencido
  if (diasRestantes < 0) {
    return (
      <div className="flex items-center gap-2 px-3 py-2 bg-red-50 border border-red-200 rounded-lg">
        <AlertCircle size={18} className="text-red-600 flex-shrink-0" />
        <div className="flex-1">
          <p className="text-sm font-semibold text-red-900">Documento vencido</p>
          <p className="text-xs text-red-700">
            Hace {Math.abs(diasRestantes)} días
          </p>
        </div>
      </div>
    );
  }

  // Vence en 7 días o menos
  if (diasRestantes <= 7) {
    return (
      <div className="flex items-center gap-2 px-3 py-2 bg-red-50 border border-red-200 rounded-lg">
        <AlertTriangle size={18} className="text-red-600 flex-shrink-0" />
        <div className="flex-1">
          <p className="text-sm font-semibold text-red-900">Vence pronto</p>
          <p className="text-xs text-red-700">
            En {diasRestantes} {diasRestantes === 1 ? 'día' : 'días'}
          </p>
        </div>
      </div>
    );
  }

  // Vence en 15 días o menos
  if (diasRestantes <= 15) {
    return (
      <div className="flex items-center gap-2 px-3 py-2 bg-orange-50 border border-orange-200 rounded-lg">
        <AlertTriangle size={18} className="text-orange-600 flex-shrink-0" />
        <div className="flex-1">
          <p className="text-sm font-semibold text-orange-900">Próximo a vencer</p>
          <p className="text-xs text-orange-700">
            En {diasRestantes} días
          </p>
        </div>
      </div>
    );
  }

  // Vence en 30 días o menos
  if (diasRestantes <= 30) {
    return (
      <div className="flex items-center gap-2 px-3 py-2 bg-yellow-50 border border-yellow-200 rounded-lg">
        <Clock size={18} className="text-yellow-600 flex-shrink-0" />
        <div className="flex-1">
          <p className="text-sm font-semibold text-yellow-900">Atención</p>
          <p className="text-xs text-yellow-700">
            Vence en {diasRestantes} días
          </p>
        </div>
      </div>
    );
  }

  return null;
}
